var _g, _g2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.036771 0 0 .036771 3 0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M0 0h708.7v870.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M591.8 462.4c-1-110.1 90-163 94.1-165.6-51.2-74.9-130.8-85.1-159.2-86.3-67.7-6.9-132.2 39.9-166.6 39.9s-87.4-38.9-143.6-37.8c-73.9 1.1-142 42.9-180.1 109.1-76.7 133-19.6 330.3 55.2 438.4 36.6 52.8 80.1 112.3 137.4 110.1 55.2-2.2 76-35.7 142.6-35.7s85.4 35.7 143.6 34.6c59.3-1.2 96.9-54 133.2-107 41.9-61.3 59.2-120.7 60.2-123.8-1.3-.5-115.6-44.3-116.8-175.9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M482.3 139c30.4-36.8 50.9-88 45.3-139-43.8 1.8-96.8 29.2-128.2 66-28.1 32.5-52.8 84.6-46.1 134.6 48.7 3.8 98.6-24.9 129-61.6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)",
    transform: "matrix(.098524 0 0 .098524 89.579758 -18.770519)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.098-5.076c2.995-3.626 5.015-8.67 4.463-13.695-4.315.177-9.537 2.877-12.63 6.503-2.77 3.202-5.202 8.335-4.542 13.26 4.798.374 9.714-2.453 12.71-6.07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.7 37.457l-4.966 15.045h-6.384l16.247-47.824h7.448l16.316 47.824h-6.6l-5.113-15.045zm15.685-4.828l-4.68-13.764c-1.064-3.123-1.773-5.96-2.483-8.73h-.138l-2.414 8.66L187 32.63z",
    enableBackground: "new "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.208 29.368c0-4.394-.138-7.95-.286-11.212h5.606l.286 5.892h.138c2.552-4.187 6.6-6.67 12.207-6.67 8.306 0 14.542 7.025 14.542 17.458 0 12.345-7.517 18.444-15.606 18.444-4.542 0-8.512-2-10.572-5.4h-.138v18.66h-6.177zm6.168 9.153c0 .926.138 1.773.286 2.552 1.133 4.325 4.897 7.3 9.37 7.3 6.6 0 10.434-5.4 10.434-13.27 0-6.887-3.616-12.77-10.217-12.77-4.256 0-8.227 3.054-9.44 7.734-.217.778-.424 1.704-.424 2.552v5.892zm32.778-9.153c0-4.394-.138-7.95-.286-11.212h5.606l.286 5.892h.138c2.552-4.187 6.6-6.67 12.207-6.67 8.306 0 14.542 7.025 14.542 17.458 0 12.345-7.517 18.444-15.606 18.444-4.542 0-8.512-2-10.572-5.4h-.138v18.66h-6.177zm6.177 9.153c0 .926.138 1.773.286 2.552 1.133 4.325 4.897 7.3 9.37 7.3 6.6 0 10.434-5.4 10.434-13.27 0-6.887-3.616-12.77-10.217-12.77-4.256 0-8.227 3.054-9.44 7.734-.217.778-.424 1.704-.424 2.552v5.892zM297.1 2.126h6.246V52.5H297.1zm18.8 34.336c.138 8.444 5.537 11.92 11.774 11.92 4.473 0 7.163-.778 9.508-1.773l1.064 4.473c-2.197.995-5.96 2.128-11.42 2.128-10.572 0-16.887-6.956-16.887-17.3s6.1-18.523 16.1-18.523c11.212 0 14.187 9.862 14.187 16.178 0 1.28-.138 2.266-.217 2.906zm18.306-4.473c.07-3.97-1.635-10.148-8.66-10.148-6.315 0-9.084 5.823-9.577 10.148z",
    enableBackground: "new "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.684731dbbc44aebdac1929d15370eda3.svg";
export { ForwardRef as ReactComponent };